<template>
    <div>
        <!-- Was Touched button -->
        <v-btn
            v-if="wasAlreadyTouched"
            large
            block
            depressed
            rounded
            class="white--text"
            :style="'width:100%'"
            :color="theme.btnColorPrimary"
            @click="onAlreadyTouchedClick"
        >
            <slot name="already-touched"></slot>
        </v-btn>

        <!-- Solve Button -->
        <v-btn-toggle v-else rounded style="width:100%;" class="spotGroupedButton" :borderless="true">
            <div class="countdown-absolute">
                <EspCountdownProgress
                    ref="countdownProgress1"
                    v-show="!disableCountdown"
                    :circle="!isXsDevice"
                    color="red"
                    :finishCountDownAfterEnd="true"
                    :startEventDate="startEventDate"
                    :endEventDate="endEventDate"
                    maxWidth="50px"
                    :text="false"
                    :preText="false"
                    :countDownProgressColor="theme.btnSecondary"
                />
            </div>

            <!-- Help Button -->
            <EspButtonHelp
                v-if="hasHints"
                ref="btnHelpSystem"
                :spot="spot"
                :color="theme.buttonGreenDark"
                @help="onHelp"
                @openHint="onHint"
                @requestHint="onRequestHint"
                :disabled="disabledHelp"
            />
            <v-btn
                large
                :class="['d-block white--text overflow-hidden', 'solve-btn', { 'solve-btn--adjacent-to-help': hasHints }]"
                :style="hasHints ? (isXsDevice ? 'width:calc(100% - 75px)' : 'width:80%') : 'width:100%'"
                :color="(spotMustBeInRange(spot, settingsGpsDisabled) && !spotIsInRange(spot))?theme.btnSecondary:theme.btnColorPrimary"
                :disabled="disabled"
                @click="onClick"
            >
                <v-row no-gutters justify="center" align="center">
                    <v-col>
                        <slot></slot>
                    </v-col>
                </v-row>
            </v-btn>
        </v-btn-toggle>

        <!-- Countdown here -->
        <div v-show="!disableCountdown" style="margin-bottom: -24px;margin-top: -17px;">
            <span class="caption time-remaining" :style="{'color': theme.textColor}">
                <span :style="{'color': theme.textColor}">{{ $t('taskTime') }}: </span>
                    <b>
                        <EspCountdownProgress
                            ref="countdownProgress2"
                            class="d-inline-block"
                            @countdownEnded="onCountdownEnded"
                            :finishCountDownAfterEnd="true"
                            :startEventDate="startEventDate"
                            :endEventDate="endEventDate"
                            maxWidth="200px"
                            :circle="false"
                            :preText="false"
                        />
                    </b>
                </span>
        </div>
    </div>
</template>

<script>
import {layoutMixin} from "../../utils/layout-mixin";
import {eventMixin} from "../../utils/event-mixin";
import {solutionMixin} from "../../utils/solution-mixin";
import EspCountdownProgress from "../countdown/EspCountdownProgress.vue";
import EspButtonHelp from "./EspButtonHelp.vue";
export default {
    mixins: [layoutMixin, solutionMixin, eventMixin],
    components: {
        EspButtonHelp,
        EspCountdownProgress
    },
    props: {
        spot: {},
        wasAlreadyTouched: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        disabledHelp: {
            type: Boolean,
            default: false
        },
        disableCountdown: {
            type: Boolean,
            default: true
        },
        showHints: {
            type: Boolean,
            default: false
        },
        startEventDate: {
            type: String
        },
        endEventDate: {
            type: String
        },
        spanColor: {},
        buttonColor:{}
    },
    created() {
        this.assignPseudoElementStyle();
    },
    data() {
        return {
            spanColorValue: this.spanColor,
            buttonColorValue: this.buttonColor
        };
    },
    computed: {
        hasHints() {
            // console.log("hasHints", this.spot.raetsel.hints);
            return this.showHints && this.spot && this.spot.raetsel && this.spot.raetsel.hints;
        }
    },
    methods: {
        onClick(val) {
            this.$emit('click', val);
        },
        onHelp(val) {
            this.$emit('help', val);
        },
        onHint(val) {
            this.$emit('openHint', val);
        },
        onRequestHint(hintId) {
            this.$emit('requestHint', hintId);
        },
        onCountdownEnded(val) {
            this.$emit('countdownEnded', val);
        },
        onAlreadyTouchedClick(val) {
            this.$emit('alreadyTouchedClick', val);
        },
        setHelpSystemState(foundPasswordSpot) {
            if (this.$refs.btnHelpSystem) {
                this.$refs.btnHelpSystem.reset(foundPasswordSpot);
            }
        },
        stopCountdown() {
            if (this.$refs.countdownProgress1 && this.$refs.countdownProgress2) {
                this.$refs.countdownProgress1.stopCountdown();
                this.$refs.countdownProgress2.stopCountdown();
            }
        },
        assignPseudoElementStyle() {
            this.spanColorValue = this.theme.btnTextColor;
            this.buttonColorValue = this.theme.btnColorPrimary;
            document.documentElement.style.setProperty('--span-btn-color', this.spanColorValue);
            document.documentElement.style.setProperty('--btn-color', this.buttonColorValue);
        }
    }
};
</script>

<style lang="scss">
.spotGroupedButton {
    .col {
        color: var(--span-btn-color);
        span {
            color: var(--span-btn-color) !important;
        }
    }
}
.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined):not(.v-progress-circular){
    background-color: var(--btn-color) !important;
    opacity: 0.5 !important;
    color: var(--span-btn-color) !important;
}
.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    color: var(--span-btn-color) !important;
}

.theme--light.v-btn-toggle:not(.v-btn-toggle--group) {
    background-color: transparent !important;
}


.countdown-absolute {
    position: absolute;
    z-index: 1;
    top: 7px;
    left: 10px;
}

.time-remaining {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    white-space: break-spaces;
    margin-bottom: 3px;
}

.v-application--is-ltr .v-btn-toggle > .v-btn.v-btn:nth-child(1) {
    border-top-left-radius: inherit;
    border-bottom-left-radius: inherit;
}

.v-application--is-ltr .v-btn-toggle .help-btn {
    border-top-left-radius: 24px;
    border-bottom-left-radius: 24px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

.v-application--is-ltr .v-btn-toggle .solve-btn:not(.solve-btn--adjacent-to-help) {
    border-top-left-radius: 24px;
    border-bottom-left-radius: 24px;
    border-top-right-radius: 24px;
    border-bottom-right-radius: 24px;
}

.v-application--is-ltr .v-btn-toggle .solve-btn.solve-btn--adjacent-to-help {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-top-right-radius: 24px;
    border-bottom-right-radius: 24px;
}

</style>
